import type { GA4TrafficSource } from "@/services/ga4Service";

export interface TrafficSourcesListProps {
	sources: GA4TrafficSource[];
}

// Traffic source bar colors — semantic tokens only
const SOURCE_BAR_COLORS: Record<string, string> = {
	"Organic Search": "bg-teal",
	Direct: "bg-coral",
	Social: "bg-violet",
	Referral: "bg-amber",
};

export function TrafficSourcesList({ sources }: TrafficSourcesListProps) {
	return (
		<div className="space-y-3 p-4">
			{sources.map((source) => (
				<div key={source.source}>
					<div className="flex items-center justify-between text-sm">
						<span className="text-foreground">{source.source}</span>
						<span className="font-medium">{source.sessions.toLocaleString()} <span className="ml-1 text-xs text-muted-foreground">({source.percentage}%)</span></span>
					</div>
					<div className="mt-1 h-2 w-full overflow-hidden rounded-full bg-muted">
						<div className={`h-full rounded-full transition-all ${SOURCE_BAR_COLORS[source.source] ?? "bg-muted-foreground"}`} style={{ width: `${source.percentage}%` }} />
					</div>
				</div>
			))}
		</div>
	);
}
